import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import styles from './MyCharityLots.styles.module.scss';
import { Carousel } from 'antd';
import defaultImage from '../../assets/img/charityHeartLogo.svg';
import { useStores } from 'stores';
import Spinner from 'components/Spinner';
import classNames from 'classnames';
import CharityBannerItem from './CharityBannerItem/CharityBannerItem';

interface CharityBannerLotsProps {
  onClose: () => void;
}

const CharityBannerLots: React.FC<CharityBannerLotsProps> = observer(({ onClose }) => {
  const { 
    charityBannerStore: { banners, fetchBanners, isLoading }
   } = useStores();

  useEffect(() => {
    if (banners.length === 0) {
      fetchBanners();
    }
  }, [banners.length]);

  if (isLoading) {
    return <Spinner />;
  }

  if (!banners || banners.length === 0)
  {
    return (
      <CharityBannerItem
        className={classNames(styles.banner, styles.bannerDefault)}
        title="Title"
        organization="Organization"
        description={`Description\n\nLooks like you have no banners.\nGo ahead and create a new one.`}
        image={defaultImage}
        link="/"
        onClose={onClose}
        isDefault={true}
      />
    );
  }


  return (
    <div className={styles.carousel_container}>
      <Carousel arrows={banners.length > 1} infinite dots={false} autoplay autoplaySpeed={15000}>
        {banners.map((banner, index) => (
          <CharityBannerItem
            key={index}
            className={classNames(styles.banner, styles[`banner-${index % 3}`])}
            title={banner.title}
            organization={banner.organization}
            description={banner.description}
            image={banner.image || defaultImage}
            link={banner.link}
            onClose={onClose}
            isDefault={false}
          />
        ))}
      </Carousel>
    </div>
  );
});

export default CharityBannerLots;
